export default "__VITE_ASSET__5662ad59__"